import { combineReducers } from 'redux';

import activeEditor from './activeTiptapEditorReducer';
import editorsById from './tiptapEditorsByIdReducer';

export default combineReducers({
    activeEditor,
    editorsById,
});
